import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./Navbar/NavBar";
import Footer from "./Footer/Footer";
import HomePage from "./Components/HomePage/HomePage";
import UpscMath2027Details from "./Components/Courses/CourseDetailspage/UpscMath2027Details";
import ContactUs from "./Footer/ContactUs";
import WriteFeedback from "./Footer/WriteFeedback";
import FAQPage from "./Footer/FAQPage";
import SucessStories from "./Footer/SuccessStories";
import Careers from "./Footer/Careers";
import AboutUs from "./Footer/AboutUs";
import Blog from "./Footer/Blog/Blog";
import TermsAndConditions from "./Footer/TermsAndConditions";
import PrivacyPolicy from "./Footer/PrivacyPolicy";
import RefundPolicy from "./Footer/RefundPolicy";
import VerificationPortal from "./Components/VerificationPortal/VerificationPortal";
import UPSCMathematicsPYQ from "./Components/PYQ/UPSCMathematics";
import BPSCMathematicsPYQ from "./Components/PYQ/BPSCMathematics";
import CSATPYQ from "./Components/PYQ/CSATPYQ";
import MentorshipPage from "./Components/MentorshipPage/MentorshipPage";
import StudTalks from "./Components/Courses/StudTalks/StudTalks";
import EBookStore from "./E-Book store/E-bookStore";
import ExamCorner from "./ExamCorner/ExamCorner";
import ScrollHandler from "./utils/ScrollHandler"; // Keep this import

function App() {
  return (
    <Router>
      <NavBar />
      <ScrollHandler /> {/* Add this as a component, NOT as a route */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/upsc-math-twentySeven" element={< UpscMath2027Details/>}/>
        <Route path="/Contact-Us" element={<ContactUs />}/>
        <Route path="/write-feedback" element={<WriteFeedback />}/>
        <Route path="/FAQ-Page" element={<FAQPage />}/>
        <Route path="/Sucess-Stories" element={<SucessStories />}/>
        <Route path="/Careers" element={<Careers />}/>
        <Route path="/About-us" element={<AboutUs />}/>
        <Route path="/Blog/*" element={<Blog />}/>
        <Route path="/terms-and-conditions" element={<TermsAndConditions />}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy />}/>
        <Route path="/refund-policy" element={<RefundPolicy />}/>
        <Route path="/verify" element={<VerificationPortal />} />
        <Route path="/upsc-pyq" element={<UPSCMathematicsPYQ />} />
        <Route path="/bpsc-pyq" element={<BPSCMathematicsPYQ />} />
        <Route path="/csat-pyq" element={<CSATPYQ />} />
        <Route path="/mentorship-page" element={<MentorshipPage />} />
        <Route path="/stud-talks" element={<StudTalks />} />
        <Route path="/ebook-store" element={<EBookStore />} />
        <Route path="/exam-corner" element={<ExamCorner />} />

      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;